<template>
  <div class="relative inline-flex items-center justify-center p-2">
    <SelfFlow />
    <BaseMemberAvatar :member="member" class="relative z-10" />
  </div>
</template>
<script lang="ts" setup>
  import type { AvatarMemberAttributes } from '../base/avatar/avatar-props.ts'
  import BaseMemberAvatar from '../base/avatar/BaseMemberAvatar.vue'
  import SelfFlow from './SelfFlow.vue'

  interface Props {
    member: AvatarMemberAttributes
  }

  const { member } = defineProps<Props>()
</script>
